module.exports = __webpack_public_path__ + "body1-num.png?6bf8d79c11c47555e2571799bec39600";


//////////////////
// WEBPACK FOOTER
// ./src/assets/body1-num.png
// module id = 160
// module chunks = 0